/* eslint-disable react-hooks/exhaustive-deps, consistent-return */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';

import useCannedDashboardsManipulation from 'hooks/useCannedDashboardsManipulation';

import Dialog from 'components/Dialog';
import ButtonClose from 'components/buttons/ActionButtons/MaximizeButton/components/ButtonCloseMaximize';
import renderPopupBody from './renderPopupBody';

const DashboardOverrideDialog = ({
  isOpen,
  handleClose,
  dashboardMenuProps,
  dispatchCannedDashboardList,
  dashboardsCount
}) => {
  const { operation, masterObjectId } = (dashboardMenuProps && dashboardMenuProps) || {};
  const [state, updateDashboardSet, resetDashboardSet] = useCannedDashboardsManipulation(
    masterObjectId,
    dispatchCannedDashboardList
  );
  const { isLoading, isError, data } = state;

  const deleteSubmit = () => {
    updateDashboardSet({ ...dashboardMenuProps, newDashboardId: null });
  };
  const onClose = () => {
    handleClose();
  };

  useEffect(() => {
    if (isLoading || isError) return;

    if (data) {
      onClose();
    }

    return () => {
      if (data) {
        delete state.data;
      }
    };
  }, [data, isError, isLoading, handleClose, dashboardMenuProps, onClose]);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      backdrop="#346C9F73"
      maxWidth={operation === 'save' ? 'md' : 'sm'}
    >
      <Box width="100%" p={3} boxShadow={2}>
        {renderPopupBody({
          operation,
          handleSubmit: updateDashboardSet,
          deleteSubmit,
          resetSubmit: resetDashboardSet,
          onClose,
          state,
          dashboardMenuProps,
          dashboardsCount
        })}
      </Box>
      <ButtonClose handleClose={onClose} iconColor="#FFF" />
    </Dialog>
  );
};

DashboardOverrideDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  dashboardMenuProps: PropTypes.shape({}),
  dispatchCannedDashboardList: PropTypes.func.isRequired,
  dashboardsCount: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired
};

DashboardOverrideDialog.defaultProps = {
  dashboardMenuProps: null
};

export default DashboardOverrideDialog;
